import React from 'react';
import {Close, DeleteModalIcon} from "../../icons/icons";
import {useTranslation} from "react-i18next";
import CustomButton from "../UI/customButton/customButton";

const DeleteModal = ({onClose , onDelete , loading}) => {
  const {t} = useTranslation()
  return (
    <div onClick={(e) => e.target === e.currentTarget && onClose()} className={"fixed top-0 right-0 bg-modal w-full h-full z-50 flex justify-center items-center "}>
      <div className={"bg-white rounded-lg p-5 w-[350px]"}>
        <div className={"flex justify-end w-full"}>
          <button onClick={() => onClose()}>
            <Close color={"black"}/>
          </button>
        </div>
        <div className={"flex justify-center"}>
          <DeleteModalIcon/>
        </div>
        <div className={"text-primary-400 my-5"}>
          {
            t("deleteTitle")
          }
        </div>
        <div className={"bg-gray-100 my-5 rounded-lg p-4 text-xs text-gray-900 leading-5"}>
          {
            t("deleteDes")
          }
        </div>
        <div className={"grid grid-cols-2 pt-2 gap-5"}>
          <CustomButton loading={loading} onClick={() => onDelete()} styles={"!text-red bg-white !text-sm border border-white"} title={t("yesDelete")} />
          <CustomButton onClick={() => onClose()} styles={"!text-sm !p-0 "} title={t("doNotDelete")} />

        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
